import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
var ListWrapper = _ref => {
  var {
    children,
    id,
    ordered,
    UNSAFE_props
  } = _ref;
  var styles = {
    margin: 0,
    paddingLeft: 0
  };
  if (ordered) {
    return /*#__PURE__*/React.createElement("ol", _extends({
      id: id,
      role: "list"
    }, UNSAFE_props, {
      style: styles
    }), children);
  }
  return /*#__PURE__*/React.createElement("ul", _extends({
    id: id,
    role: "list"
  }, UNSAFE_props, {
    style: styles
  }), children);
};
ListWrapper.displayName = 'ListWrapper';
export { ListWrapper };
//# sourceMappingURL=ListWrapper.js.map